module.exports = __webpack_public_path__ + "img/certificate-3-lg@3x.853ee67d.png";